import { render } from "./Brand.vue?vue&type=template&id=aa3dc67e&ts=true"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__